import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { of, throwError } from 'rxjs';
import { estaEnElDemo } from './demo';
import { respuestaDelDemo, saleDeEsteNavegador } from './respuestas-del-demo';

/**
 * En el demo, nada sale de este navegador (decisión de Santiago, 18/09): lo que el demo sabe contestar se contesta
 * aquí; lo demás falla como «sin red» (estado 0), que la caja ya trata sin ventanas de error y con su aviso de
 * conexión. Va el primero de la cadena (`app.config.ts`): primero se decide si la petición sale.
 *
 * Fuera del demo no hace nada.
 */
export const demoInterceptor: HttpInterceptorFn = (req, next) => {
  if (!estaEnElDemo() || !saleDeEsteNavegador(req.urlWithParams, location.origin)) {
    return next(req);
  }
  const r = respuestaDelDemo(req.method, req.urlWithParams, req.body);
  if (!r) {
    console.warn(`[demo] sin respuesta en el demo, no sale a la red: ${req.method} ${req.url}`);
    return throwError(() => new HttpErrorResponse({ status: 0, statusText: 'Demo sin red', url: req.url }));
  }
  return of(new HttpResponse({ status: r.status, body: r.body, url: req.url }));
};
